import { useState, useEffect } from "react";

// Near the top of the page the header always stays put, so a downward flick on
// the first screen doesn't take it away before there's anything to read.
const ALWAYS_VISIBLE_OFFSET = 80;
// Trackpads and momentum scrolling emit streams of tiny, often opposite-signed
// deltas; ignoring the small ones keeps the header from flickering mid-gesture.
const DIRECTION_THRESHOLD = 8;

export default function useHeaderHidden() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let lastY = window.scrollY;
    let ticking = false;

    const update = () => {
      ticking = false;

      const y = window.scrollY;
      const delta = y - lastY;
      // lastY only moves once the threshold is cleared, so slow scrolling
      // accumulates towards a direction change instead of being discarded.
      if (Math.abs(delta) < DIRECTION_THRESHOLD) return;

      lastY = y;
      setHidden(delta > 0 && y > ALWAYS_VISIBLE_OFFSET);
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return hidden;
}
